import { Game } from '@betty/games';
import { memo } from 'react';
import { useTranslation } from '@betty/i18n';
import { Box, Text } from '@betty/moonlight';

function FreeSpinGame({ id, spinsLeft }: { id: number; spinsLeft?: number }) {
  const { t } = useTranslation('rewards');

  return (
    <Box>
      <Game id={id} imageType="square" zIndex={2} />
      <Box
        backgroundColor="accentSolidBackground"
        width="50%"
        height={50}
        position="absolute"
        bottom="space-400"
        left="space-0"
        zIndex={1}
      />
      <Box
        variant="gradient"
        gradient="accentBackground"
        paddingHorizontal="space-300"
        paddingVertical="space-200"
        borderRadius="radius-400"
        zIndex={1}
      >
        <Text variant="body-m" textAlign="center">
          {t('spinsWithCount', { count: spinsLeft })}
        </Text>
      </Box>
    </Box>
  );
}

export default memo(FreeSpinGame);
